import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faFlask from '@fortawesome/fontawesome-pro-solid/faFlask';
// styles
import '../../css/header.css';
// comps
import HoverLogo from './HoverLogo';
import Link from "../global/Link";

const Header = () => (

    <div className={'header'}>
        <div className={'header--topNavBar'}>
            <div>Lab for: <a href='https://artfly.io/' target="_blank" rel="noopener noreferrer">ArtFly.io</a></div>
            {/*<a href='https://blog.artfly.io/' target="_blank" rel="noopener noreferrer">BLOG</a>*/}
            {/*<a href='https://www.facebook.com/artfly.io/' target="_blank"  rel="noopener noreferrer">Facebook</a>*/}
        </div>
        <h1>
            <HoverLogo />

            <Link to="/">
                <span className={'header--letter header--letter--a'}>A</span>
                <span className={'header--letter header--letter--r'}>r</span>
                <span className={'header--letter header--letter--t'}>t</span>
                <span className={'header--letter header--letter--f'}>F</span>
                <span className={'header--letter header--letter--l'}>l</span>
                <span className={'header--letter header--letter--y'}>y</span>

                <span className={'header--letter header--blogText'}>
                    <FontAwesomeIcon icon={faFlask} /> LAB
                </span>
            </Link>
        </h1>
    </div>

);

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.js